import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isRequesting: false,
    error: null,
    // Danh sách bảng kê tổng hợp thu tiền
    data: {},
    total: 0,
    searchCriteria: {},
};
const slice = createSlice({
    name: 'cashierDepositOrder',
    initialState: initialState,
    reducers: {
        get_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload },
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload,
                total: action.payload?.total || 0,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: [],
                total: 0,
            };
        },

        save_cashier_deposit: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        save_cashier_deposit_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },

        delete_cashier_deposit: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        delete_cashier_deposit_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        request_export_success: (state) => {
            const { export: exportData, ...restSearchCriteria } = state.searchCriteria;
            return {
                ...state,
                isRequesting: false,
                searchCriteria: {
                    ...restSearchCriteria,
                },
            };
        },
        reset_state: () => {
            return initialState;
        },
        fail: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
